import React, { ReactNode } from 'react';
import CheckPermission from 'components/common/CheckPermissions';
import TextFallback from './Fallback';
import { CustomTextStyles } from './styles';

interface Props {
  permissionKey?: string;
  action?: string;
  isSkipSubscription?: boolean;
  packageName?: string;
  isBlur?: boolean;
  textValue?: string;
  icon?: ReactNode;
  centreId?: string;
}

const CustomText = ({
  permissionKey,
  action,
  isSkipSubscription,
  packageName,
  isBlur,
  textValue,
  icon,
  centreId,
}: Props) => (
  <CustomTextStyles className="relative">
    <CheckPermission
      isBlur={isBlur}
      packageName={packageName}
      permissionKey={permissionKey}
      action={action}
      isSkipSubscription={isSkipSubscription}
      isDisabled
      fallback={
        <TextFallback
          centreId={centreId}
          isBlur={isBlur}
          icon={icon}
          textValue={textValue}
        />
      }
    >
      <div className="flex items-center">
        {icon}
        <span className="break-all">{textValue}</span>
      </div>
    </CheckPermission>
  </CustomTextStyles>
);

export default CustomText;
